import type { ReactNode } from 'react';
import { DashboardPageFrame } from '../DashboardPageFrame';

interface CompanyAccountHeaderProps {
  title?: string;
  description?: string;
}

interface CompanyAccountWrapperProps extends CompanyAccountHeaderProps {
  children: ReactNode;
}

export function CompanyAccountWrapper({
  title,
  description,
  children,
}: CompanyAccountWrapperProps) {
  return (
    <DashboardPageFrame
      title={title ?? 'Company Account Settings'}
      description={
        description ??
        'Manage company details, branding, and white-label configuration.'
      }
    >
      {children}
    </DashboardPageFrame>
  );
}
